<template>
  <div class="cal__body">
        <AppBodyHeader v-if="this.$store.state.device === 'desktop'" />
        <div class="cal__body_content">
            <div class="cal__body_jobs">
                <JobCategory v-bind:category="{idCategory: 1, name: 'Conseil'}" />
                <JobCategory v-bind:category="{idCategory: 2, name: 'Création'}" />
                <JobCategory v-bind:category="{idCategory: 3, name: 'Technique / Dev'}" />               
            </div>
            <div class="cal__body_total" 
                v-if="this.$store.state.device === 'mobile'"
                id="cal__body_total_mobile"
            >
                <div class="cal__total_container">
                    <div class="cal__total_line1">
                        <div class="cal__total_title cal__font_bree">Budget prévisionnel</div>
                        <div class="cal__total_input">
                            <input name="" value="" disabled />
                            <Odometer />
                        </div>
                    </div>
                    <div class="cal__total_footer">incluant 15% de frais de gestion de projet. Montant HT</div>
                </div>
            </div>
            <div class="cal__body_total" v-if="this.$store.state.device !== 'mobile'">
                <div class="cal__bloc_header cal__font_bree" v-if="this.$store.state.device === 'mobile'">
                    <span class="cal__bloc_number">=</span>
                    <span class="cal__bloc_title">Budget</span>
                </div>
                <div class="cal__total_container">
                    <div class="cal__total_title cal__font_bree">Budget <br class="cal--is-desktop">prévisionnel de <br class="cal--is-desktop">votre projet digital</div>
                    <div class="cal__total_input">
                        <input name="" value="" disabled />
                        <div class="cal__odometer_container">
                            <Odometer />
                        </div>
                    </div>
                    <div class="cal__total_footer">incluant 15% de frais de gestion de projet.<br>Montant HT</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import AppBodyHeader from './AppBodyHeader.vue'
import JobCategory from './JobCategory.vue'
import Odometer from './Odometer.vue'

export default {
  name: 'AppBody',
  components: {
    AppBodyHeader,
    JobCategory,
    Odometer
  }
}
</script>
